var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.4995 2.43824L15.5942 11.1476C16.1244 12.0438 16.1358 13.1548 15.6242 14.0618C15.1119 14.9698 14.1545 15.5337 13.1002 15.544L2.89104 15.5439C1.84761 15.5354 0.888332 14.9698 0.376015 14.061C-0.135877 13.1529 -0.123921 12.0394 0.404559 11.1508L5.50114 2.43828C6.01898 1.54687 6.97263 0.998795 8.00371 1C9.03469 1.00121 9.988 1.55155 10.4995 2.43824ZM8.73038 5.36255H7.27539V10.4534H8.73038V5.36255ZM8.72819 11.9077C8.72819 12.3093 8.40248 12.6349 8.00069 12.6349C7.5989 12.6349 7.27319 12.3093 7.27319 11.9077C7.27319 11.506 7.5989 11.1804 8.00069 11.1804C8.40248 11.1804 8.72819 11.506 8.72819 11.9077Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.0e6d5fcf5ebec50387f6492e4869920f.svg";
export { ForwardRef as ReactComponent };